module.exports = "<div class=\"container\">\n  \n</div>\n"